import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'demographics',
    label: 'Demographics',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
